import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useDayPicker } from 'contexts/DayPicker';
/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */
export function CaptionLabel(props) {
    var _a = useDayPicker(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (_jsx("div", __assign({ className: classNames.caption_label, style: styles.caption_label, "aria-live": "polite", role: "presentation", id: props.id }, { children: formatCaption(props.displayMonth, { locale: locale }) })));
}
//# sourceMappingURL=CaptionLabel.js.map